import { render } from "./TermsRecruit.vue?vue&type=template&id=4506ed22"
import script from "./TermsRecruit.vue?vue&type=script&lang=js"
export * from "./TermsRecruit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__